module.exports = __webpack_public_path__ + "img/red-2-diamond-striped.dcbc7f0f.svg";